export default {
    methods: {
        exibirFimPropostasELances(amparoLegal) {
            if (this.ehLei14_133(amparoLegal))
                return this.$store.state.parametros.propriedadesCompraDiretas.exibirFimEnvioPropostaLei14133
            else if (this.ehLei13_303(amparoLegal))
                return this.$store.state.parametros.propriedadesCompraDiretas.exibirFimEnvioPropostaLei13303
            else
                return this.$store.state.parametros.propriedadesCompraDiretas.exibirFimEnvioPropostaLei8666
        }
    }
}